import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import EmailPulseDataGrid from '../../email-pulse-data-grid/email-pulse-data-grid.component';
import {
  getSecurityDataGridColumns,
  securityColumnVisibilityModel,
} from '../security.config';
import { EmailPulseExportMutationHook } from '../../email-pulse.types';

type SecurityDataGridProps = {
  'data-testid': string;
  queryName: string;
  useExportMutation: EmailPulseExportMutationHook;
};

/**
 * Security tab data grid component.
 * Wrapper around the generic EmailPulseDataGrid with Security-specific configuration.
 */
const SecurityDataGrid = ({
  queryName,
  useExportMutation,
  ...rest
}: SecurityDataGridProps) => {
  const { t } = useTranslation();

  const columns = useMemo(() => getSecurityDataGridColumns(t), [t]);

  return (
    <EmailPulseDataGrid
      columns={columns}
      columnVisibilityModel={securityColumnVisibilityModel}
      exportFileType="SECURITY"
      queryName={queryName}
      useExportMutation={useExportMutation}
      pinnedLeftColumn="title"
      {...rest}
    />
  );
};

export default SecurityDataGrid;
